package com.trevorwiebe.timesheet.admin.reporting.presentation.components

import androidx.compose.foundation.layout.widthIn
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import com.trevorwiebe.timesheet.admin.reporting.domain.LoadWithoutTruck
import com.trevorwiebe.timesheet.admin.reporting.presentation.ReportingEvent
import com.trevorwiebe.timesheet.admin.reporting.presentation.SetTruckState
import com.trevorwiebe.timesheet.core.domain.Util
import com.trevorwiebe.timesheet.core.presentation.common.responsiveDialogWidth
import com.trevorwiebe.timesheet.mileage.domain.model.Equipment

@Composable
fun LoadWithoutTruckRow(row: LoadWithoutTruck, onClick: () -> Unit) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = 12.dp, vertical = 8.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                text = Util.toFriendlyDate(row.date) +
                    if (row.loadNumber.isNotBlank()) "  #${row.loadNumber}" else "",
                fontSize = 14.sp,
                fontWeight = FontWeight.SemiBold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f),
            )
            Text(
                text = row.statusText,
                fontSize = 13.sp,
                color = MaterialTheme.colorScheme.error,
                maxLines = 1,
                modifier = Modifier.padding(start = 8.dp),
            )
        }
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                text = "${row.customerName} • ${row.driverName}",
                fontSize = 14.sp,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f),
            )
            Text(
                text = row.dropNames,
                fontSize = 13.sp,
                color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.7f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                textAlign = TextAlign.End,
                modifier = Modifier.padding(start = 8.dp).widthIn(max = 180.dp),
            )
        }
    }
    HorizontalDivider()
}

@Composable
fun SetTruckDialog(
    dialog: SetTruckState,
    trucks: List<Equipment>,
    onEvent: (ReportingEvent) -> Unit,
) {
    Dialog(onDismissRequest = { onEvent(ReportingEvent.OnDismissSetTruck) }) {
        Card(modifier = Modifier.responsiveDialogWidth(), shape = RoundedCornerShape(16.dp)) {
            Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
                Text(text = "Set Truck", fontSize = 20.sp, fontWeight = FontWeight.SemiBold)
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    text = "${Util.toFriendlyDate(dialog.row.date)} • ${dialog.row.customerName} • " +
                        dialog.row.driverName,
                    fontSize = 14.sp,
                )
                Spacer(modifier = Modifier.height(12.dp))
                LazyColumn(modifier = Modifier.heightIn(max = 360.dp)) {
                    items(trucks, key = { it.id }) { truck ->
                        Text(
                            text = "Unit ${truck.unitNumber}",
                            fontSize = 16.sp,
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable(enabled = !dialog.isSaving) {
                                    onEvent(ReportingEvent.OnTruckSelected(truck.id))
                                }
                                .padding(vertical = 12.dp),
                        )
                        HorizontalDivider()
                    }
                }
                dialog.error?.let {
                    Spacer(modifier = Modifier.height(8.dp))
                    Text(text = it, fontSize = 14.sp, color = MaterialTheme.colorScheme.error)
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                    TextButton(onClick = { onEvent(ReportingEvent.OnDismissSetTruck) }) {
                        Text("Cancel", color = MaterialTheme.colorScheme.tertiary)
                    }
                }
            }
        }
    }
}
